module.exports = __webpack_public_path__ + "static/top-remit-impact-8e375bf3a6675d5574a3b4fa2998df83.jpg";